import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Button, Modal } from "react-bootstrap";
import { ButtonLoader } from "Components";
import { authService } from "Service/Axios";
import { FORM_BUILDER_FORM_DUPLICATE_URL } from "Constant/api";
import { Validator } from "Utils/validator";

export const DuplicateForm = ({
  show,
  selectedForm,
  toggle,
  fetchFolderList,
}) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    formName: "",
    coverName: "",
  });
  const [errMsg, setErrMsg] = useState({
    formName: "",
    coverName: "",
  });

  const { formName, coverName } = formData;

  // On Change
  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));

    if (e.target.name === "formName") {
      if (!Validator.text(e.target.value)) {
        setErrMsg((prev) => ({
          ...prev,
          formName: t("common.messages.error.common.formName.blank"),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          formName: "",
        }));
      }
    }

    if (e.target.name === "coverName") {
      if (!Validator.text(e.target.value)) {
        setErrMsg((prev) => ({
          ...prev,
          coverName: t("common.messages.error.common.coverName.blank"),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          coverName: "",
        }));
      }
    }
  };

  const getValidation = () => {
    return new Promise((resolve) => {
      if (Validator.text(formName) && Validator.text(coverName)) {
        resolve(true);
      } else {
        if (!Validator.text(formName)) {
          setErrMsg((prev) => ({
            ...prev,
            formName: t("common.messages.error.common.formName.blank"),
          }));
        }
        if (!Validator.text(coverName)) {
          setErrMsg((prev) => ({
            ...prev,
            coverName: t("common.messages.error.common.coverName.blank"),
          }));
        }
        resolve(false);
      }
    });
  };

  // On Submit
  const onSaveForm = async () => {
    const validationStatus = await getValidation();
    if (validationStatus) {
      setLoading(true);
      try {
        if (selectedForm && selectedForm?.formId) {
          const payload = {
            formId: selectedForm?.formId,
            folderId: selectedForm?.folderId,
            formName,
            formCoverName: coverName,
          };
          const response = await authService(
            FORM_BUILDER_FORM_DUPLICATE_URL,
            "POST",
            payload
          );
          setLoading(false);
          if (response) {
            if (response.success) {
              toast.success(
                t("common.messages.notification.success.createForm")
              );
              toggle();
              fetchFolderList();
            } else {
              if (
                response.message ===
                "The form has already exist under this folder."
              ) {
                toast.error(
                  t("common.messages.notification.failed.duplicateForm")
                );
              } else {
                toast.error(response.message);
              }
            }
          }
        }
      } catch (error) {
        setLoading(false);
        if (error.response && error.response.data) {
          toast.error(error.response.data.message);
        }
      }
    }
  };

  return (
    <Modal
      show={show}
      onHide={toggle}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="justify-content-center">
        <Modal.Title>{t("auth.formBuilder.duplicateForm")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-4">
          <label className="form-label" htmlFor="formName">
            {t("common.label.newFormName")}
          </label>
          <input
            type="text"
            className="form-control"
            id="formName"
            placeholder={t("common.placeHolder.formName")}
            name="formName"
            value={formName}
            onChange={handleChange}
          />
          {errMsg.formName && <p className="error">{errMsg.formName}</p>}
        </div>
        <div>
          <label className="form-label" htmlFor="coverName">
            {t("common.label.coverName")}
          </label>
          <input
            type="text"
            className="form-control"
            id="coverName"
            placeholder={t("common.placeHolder.coverName")}
            name="coverName"
            value={coverName}
            onChange={handleChange}
          />
          {errMsg.coverName && <p className="error">{errMsg.coverName}</p>}
        </div>
      </Modal.Body>
      <Modal.Footer className="border-0 justify-content-center">
        <Button variant="outline-primary" onClick={toggle} className="">
          {t("common.button.cancel")}
        </Button>
        {!loading ? (
          <Button variant="primary" onClick={onSaveForm}>
            {t("common.button.duplicate")}
          </Button>
        ) : (
          <ButtonLoader />
        )}
      </Modal.Footer>
    </Modal>
  );
};
